"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.togglePanel = exports.setPanelHeight = exports.propTypes = exports.getTitleStyle = exports.defaultProps = exports.default = exports.Accordion = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _Icon = _interopRequireDefault(require("../Icon/Icon"));
var _Text = _interopRequireDefault(require("../Text/Text"));
var utils = _interopRequireWildcard(require("./Accordion"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Accordion component
 *
 * @method
 * @param { AccordionProps } props
 * @returns Accordion
 */
/**
 * Primary UI component for user interaction
 */
const Accordion = props => {
  const {
    ariaControls = defaultProps.ariaControls,
    ariaLabelledBy = defaultProps.ariaLabelledBy,
    children = defaultProps.children,
    disabled = defaultProps.disabled,
    expandMore = defaultProps.expandMore,
    externalCloseAction = defaultProps.externalCloseAction,
    externalOpenAction = defaultProps.externalOpenAction,
    headerChildren = defaultProps.headerChildren,
    icon,
    isActive = defaultProps.isActive,
    setExpandMore = defaultProps.setExpandMore,
    subTitle = defaultProps.subTitle,
    title = defaultProps.title,
    titleTag = defaultProps.titleTag,
    variant = defaultProps.variant,
    ...other
  } = props;
  const panelRef = (0, _react.useRef)();
  const [heightVar, setHeight] = (0, _react.useState)('0');
  const [isActiveVar, setIsActive] = (0, _react.useState)(!!isActive);
  const [ariaControlsVar, setAriaControls] = (0, _react.useState)();
  const [ariaLabelledByVar, setAriaLabelledBy] = (0, _react.useState)();
  const [initialState, setInitialState] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    setInitialState(true);
  }, []);
  (0, _react.useEffect)(() => {
    setAriaControls(ariaControls);
    setAriaLabelledBy(ariaLabelledBy);
    const handlePanelHeightResize = () => {
      utils.setPanelHeight({
        isActiveVar,
        panelRef,
        expandMore
      }, {
        setHeight
      });
    };
    handlePanelHeightResize();
    window.addEventListener('resize', handlePanelHeightResize); /* 2 */
    return () => {
      window.removeEventListener('resize', handlePanelHeightResize); /* 3 */
    };
  }, [isActiveVar, ariaLabelledBy, expandMore, children, heightVar]);
  const titleStyle = getTitleStyle({
    variant
  });
  const componentClassName = (0, _classnames.default)('pal-c-Accordion', {
    [`pal-c-Accordion__${variant}`]: variant,
    'pal-c-Accordion--is-active': isActiveVar === true,
    'pal-c-Accordion--disabled': disabled === true
  });
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: componentClassName
  }, other, {
    ref: panelRef
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-Accordion__header"
  }, /*#__PURE__*/_react.default.createElement("button", {
    "aria-controls": ariaControlsVar,
    "aria-expanded": !!isActiveVar,
    "aria-label": title,
    className: "pal-c-Accordion__button",
    disabled: disabled,
    id: ariaLabelledByVar
    // eslint-disable-next-line react/jsx-no-bind
    ,
    onClick: () => utils.togglePanel({
      isActiveVar,
      externalOpenAction,
      externalCloseAction,
      panelRef
    }, {
      setHeight,
      setIsActive,
      setExpandMore,
      setInitialState
    })
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-Accordion__button--top"
  }, icon && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-Accordion__content--icon"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    className: "pal-c-Accordion__icon--component",
    disabled: disabled,
    name: icon,
    size: "custom"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-Accordion__content--text"
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    htmlTag: titleTag,
    textColor: disabled ? 'default-disabled' : 'content-default',
    textStyle: titleStyle
  }, title), subTitle && /*#__PURE__*/_react.default.createElement(_Text.default, {
    htmlTag: "p",
    textColor: "xsubtle",
    textStyle: "body-sm"
  }, subTitle), headerChildren && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-Accordion__headerChildren"
  }, headerChildren))), /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-Accordion__icon"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    disabled: disabled,
    name: isActiveVar ? 'minus' : 'add',
    size: "lg"
  }))), children && /*#__PURE__*/_react.default.createElement("section", {
    "aria-labelledby": ariaLabelledByVar,
    className: "pal-c-Accordion__body",
    id: ariaControlsVar,
    style: {
      height: heightVar,
      ...(initialState && isActiveVar && {
        transition: 'none'
      })
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-Accordion__body--inner"
  }, children)));
};

/**
 * Function to get the title size based on what variant it is
 * @method
 * @param {Object} data
 * @returns { String } // string for textStyle variant
 */
exports.Accordion = Accordion;
const getTitleStyle = data => {
  const {
    variant
  } = data;
  switch (variant) {
    case 'default':
      return 'title';
    case 'compact':
      return 'title-sm';
    case 'tiny':
      return 'body';
  }
};

/**
 *
 * @method setPanelHeight
 * @param {object} data - Data passed as an argument
 * @param {boolean} data.isActiveVar - set the height to panel body inner height
 * @param {ref} data.panelRef - sets ref for panel when isActiveVar or expandMore is true
 * @param {boolean} data.expandMore - boolean that controls whether to see more is clicked or not
 * @param {object} methods - Methods passed as an argument
 * @param {action} methods.setHeight - sets height of the panel
 */
exports.getTitleStyle = getTitleStyle;
const setPanelHeight = (data, methods) => {
  const {
    isActiveVar,
    panelRef,
    expandMore
  } = data || {};
  const {
    setHeight
  } = methods || {};
  if (!panelRef) {
    return;
  }
  if (isActiveVar === true || expandMore === true) {
    setHeight(panelRef.current?.querySelector('.pal-c-Accordion__body--inner')?.scrollHeight + 'px'); /* 1 */
  } else {
    setHeight('0'); /* 2 */
  }
};

/**
 *
 * @method togglePanel
 * @param {object} data - Data passed as an argument
 * @param {boolean} data.isActiveVar - set the height to panel body inner height
 * @param {ref} data.panelRef - sets ref for panel when isActiveVar or expandMore is true
 * @property {action} externalOpenAction - sends data capture events for accordion open action
 * @property {action} externalCloseAction - sends data capture events for accordion close action
 * @param {object} methods - Methods passed as an argument
 * @param {action} methods.setIsActive - sets isActiveVar if accordion is expanded or collapsed
 * @param {action} methods.setExpandMore - sets the value for expand more
 */
exports.setPanelHeight = setPanelHeight;
const togglePanel = (data, methods) => {
  const {
    isActiveVar,
    externalOpenAction,
    externalCloseAction,
    panelRef
  } = data || {};
  const {
    setIsActive,
    setExpandMore,
    setInitialState
  } = methods || {};
  if (!panelRef) {
    return;
  }
  setInitialState(false);
  if (isActiveVar === true) {
    setIsActive(false);
    setExpandMore(false);
    // here we are closing
    if (externalCloseAction) {
      externalCloseAction();
    }
  }
  if (isActiveVar === false) {
    setIsActive(true);
    // here we are opening
    if (externalOpenAction) {
      externalOpenAction();
    }
  }
};

/**
 * Property type definitions
 * @type {object}
 * @property {string} ariaControls - Links the aria-control attribute in the accordion panel header to the id in the accordion panel body
 * @property {string} ariaLabelledBy - HTML id for aria-labelledby, which associates panel contents with the accordion title
 * @property {node} children - Child node(s) that can be nested inside component
 * @property {boolean} disabled - Boolean that controls whether the accordion is disabled or not
 * @property {boolean} expandMore - Boolean that controls whether to see more is clicked or not
 * @property {action} externalCloseAction - sends data capture events for accordion close action
 * @property {action} externalOpenAction - sends data capture events for accordion open action
 * @property {node} headerChildren - A React element to be rendered as the header children
 * @property {string} icon - sets the icon in the accordion header section
 * @property {boolean} isActive - Panel is open when set to true. Close when set to false
 * @property {action} setExpandMore - sets the value for expand more
 * @property {string} subTitle - subtitle for the accordion's heading section
 * @property {string} title - title for the accordion's heading section
 * @property {string} titleTag - html tag for title for the accordion's heading section
 * @property {string} variant - Determines variation of accordion
 */
exports.togglePanel = togglePanel;
const propTypes = exports.propTypes = {
  /**
   * Links the aria-control attribute in the accordion panel header to the id in the accordion panel body
   */
  ariaControls: _propTypes.default.string,
  /**
   * HTML id for aria-labelledby, which associates panel contents with the accordion title
   */
  ariaLabelledBy: _propTypes.default.string,
  /**
   * Child node(s) that can be nested inside component
   */
  children: _propTypes.default.node,
  /**
   * disabled
   * 1) Panel is disabled when set to true. Able to click when set to false
   */
  disabled: _propTypes.default.bool,
  /**
   * Boolean that controls whether to see more is clicked or not
   */
  expandMore: _propTypes.default.bool,
  /**
    * sends data capture events for accordion close action
    */
  externalCloseAction: _propTypes.default.func,
  /**
   * sends data capture events for accordion open action
   */
  externalOpenAction: _propTypes.default.func,
  /**
   * A React element to be rendered as the header children
   */
  headerChildren: _propTypes.default.node,
  /**
   * sets the icon in the accordion header section
   */
  icon: _propTypes.default.string,
  /**
   * is Active
   * 1) Panel is open when set to true. Close when set to false
   */
  isActive: _propTypes.default.bool,
  /**
   * sets the value for expand more
   */
  setExpandMore: _propTypes.default.func,
  /**
   * subtitle for the accordion's heading section
   */
  subTitle: _propTypes.default.string,
  /**
   * title for the accordion's heading section
   */
  title: _propTypes.default.string,
  /**
   * html tag for title for the accordion's heading section
   */
  titleTag: _propTypes.default.oneOf(['p', 'h2', 'h3', 'h4', 'h5', 'h6']),
  /**
   * Determines variation of accordion
   * - **compact:** The compact accordion style
   * - **default:** The default accordion style
   * - **tiny:** The tiny accordion style
   */
  variant: _propTypes.default.oneOf(['compact', 'default', 'tiny'])
};
/**
 * Property type definitions
 * @type {object}
 * @property {string} ariaControls - sets the default value of ariaControls
 * @property {string} ariaLabelledBy - sets the default value of ariaLabelledBy
 * @property {node} children - sets the default value of children
 * @property {boolean} disabled - Boolean that controls whether the accordion is disabled or not
 * @property {boolean} expandMore - Boolean that controls whether to see more is clicked or not
 * @property {action} externalOpenAction - sends data capture events for accordion open action
 * @property {action} externalCloseAction - sends data capture events for accordion close action
 * @property {node} headerChildren - set default element as the header children
 * @property {boolean} isActive - sets the default value of isActive
 * @property {action} setExpandMore - sets the value for expand more
 * @property {string} subTitle - sets the default value of subTitle
 * @property {string} title - sets the default value of title
 * @property {string} titleTag - sets the default value of titleTag
 * @property {string} variant - sets the default value of accordion
 */
const defaultProps = exports.defaultProps = {
  ariaControls: '',
  ariaLabelledBy: '',
  children: undefined,
  disabled: false,
  expandMore: false,
  externalCloseAction: undefined,
  externalOpenAction: undefined,
  headerChildren: undefined,
  isActive: false,
  setExpandMore: () => false,
  subTitle: undefined,
  title: undefined,
  titleTag: 'h3',
  variant: 'default'
};
Accordion.propTypes = propTypes;
var _default = exports.default = Accordion;